export default __webpack_public_path__ + "static/media/girl.63dd41b3.png";